import { jsxs as N, jsx as t } from "react/jsx-runtime";
import * as x from "react";
import { cn as d } from "../../../lib/utils.js";
import { X as $, Plus as k } from "lucide-react";
import { Button as v } from "../button/Button.js";
const z = x.forwardRef(({ actions: p = [], direction: n = "up", variant: b = "default", size: c = "md", position: y = "bottom-right", contained: m = !1, className: r }, g) => {
  const [l, h] = x.useState(!1), f = {
    sm: "h-10 w-10",
    md: "h-12 w-12",
    lg: "h-14 w-14"
  }, o = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6"
  }, i = {
    "bottom-right": "bottom-6 right-6",
    "bottom-left": "bottom-6 left-6",
    "top-right": "top-6 right-6",
    "top-left": "top-6 left-6"
  }, w = (s) => {
    const a = (s + 1) * 64;
    switch (n) {
      case "up":
        return { bottom: `${a + 56}px`, right: "0px" };
      case "down":
        return { top: `${a + 56}px`, right: "0px" };
      case "left":
        return { bottom: "0px", right: `${a + 56}px` };
      case "right":
        return { bottom: "0px", left: `${a + 56}px` };
      default:
        return { bottom: `${a + 56}px`, right: "0px" };
    }
  };
  return N("div", { ref: g, className: d("z-50", m ? "absolute" : "fixed", i[y], r), children: [l && p.length > 0 && t("div", { className: "relative", children: p.map((s, e) => t("div", { className: "absolute", style: w(e), children: N("div", { className: "flex items-center gap-3", children: [b === "default" && n === "left" && t("div", { className: "bg-bg-surface border border-border-color rounded-lg px-3 py-2 shadow-card", children: t("span", { className: "text-sm font-medium text-text-primary whitespace-nowrap", children: s.label }) }), t(v, { size: "icon", variant: "secondary", onClick: s.onClick, disabled: s.disabled, className: d(f[c], "rounded-full shadow-luxury hover:shadow-glow transition-all duration-300", "animate-in fade-in zoom-in duration-200", `animation-delay-${e * 50}`), style: { animationDelay: `${e * 50}ms` }, children: s.icon }), b === "default" && n === "right" && t("div", { className: "bg-bg-surface border border-border-color rounded-lg px-3 py-2 shadow-card", children: t("span", { className: "text-sm font-medium text-text-primary whitespace-nowrap", children: s.label }) })] }) }, s.id)) }), t(v, { size: "icon", onClick: () => h(!l), className: d(f[c], "rounded-full bg-lpr-teal hover:bg-lpr-teal/90 text-bg-surface shadow-luxury hover:shadow-glow transition-all duration-300", l && "rotate-45"), children: l ? t($, { className: o[c] }) : t(k, { className: o[c] }) }), l && t("div", { className: d("inset-0 bg-bg-primary/20 backdrop-blur-sm -z-10", m ? "absolute" : "fixed"), onClick: () => h(!1) })] });
});
z.displayName = "SpeedDial";
const S = x.forwardRef(({ actions: p, trigger: n, direction: b = "up", variant: c = "default", size: y = "md", open: m, onOpenChange: r, className: g }, l) => {
  const [h, f] = x.useState(!1), o = m !== void 0, i = o ? m : h, w = () => {
    o ? r == null || r(!i) : f(!i);
  }, s = (e) => {
    const u = (e + 1) * 64;
    switch (b) {
      case "up":
        return { bottom: `${u}px`, left: "50%", transform: "translateX(-50%)" };
      case "down":
        return { top: `${u}px`, left: "50%", transform: "translateX(-50%)" };
      case "left":
        return { right: `${u}px`, top: "50%", transform: "translateY(-50%)" };
      case "right":
        return { left: `${u}px`, top: "50%", transform: "translateY(-50%)" };
      default:
        return { bottom: `${u}px`, left: "50%", transform: "translateX(-50%)" };
    }
  };
  return N("div", { ref: l, className: d("relative inline-block", g), children: [i && t("div", { className: "absolute", children: p.map((e, a) => t("div", { className: "absolute", style: s(a), children: t(v, { size: "icon", variant: "secondary", onClick: e.onClick, disabled: e.disabled, className: d("rounded-full shadow-luxury hover:shadow-glow transition-all duration-300", "animate-in fade-in zoom-in duration-200"), style: { animationDelay: `${a * 50}ms` }, title: e.label, children: e.icon }) }, e.id)) }), t("div", { onClick: w, className: "cursor-pointer", children: n }), i && t("div", { className: "fixed inset-0 bg-transparent -z-10", onClick: () => {
    o ? r == null || r(!1) : f(!1);
  } })] });
});
S.displayName = "CustomSpeedDial";
export {
  S as CustomSpeedDial,
  z as SpeedDial
};
//# sourceMappingURL=SpeedDial.js.map
